function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.5833 3.25004H16.055C15.6 1.99337 14.4083 1.08337 13 1.08337C11.5917 1.08337 10.4 1.99337 9.945 3.25004H5.41667C4.225 3.25004 3.25 4.22504 3.25 5.41671V20.5834C3.25 21.775 4.225 22.75 5.41667 22.75H20.5833C21.775 22.75 22.75 21.775 22.75 20.5834V5.41671C22.75 4.22504 21.775 3.25004 20.5833 3.25004ZM13 3.25004C13.5958 3.25004 14.0833 3.73754 14.0833 4.33337C14.0833 4.92921 13.5958 5.41671 13 5.41671C12.4042 5.41671 11.9167 4.92921 11.9167 4.33337C11.9167 3.73754 12.4042 3.25004 13 3.25004ZM15.1667 18.4167H7.58333V16.25H15.1667V18.4167ZM18.4167 14.0834H7.58333V11.9167H18.4167V14.0834ZM18.4167 9.75004H7.58333V7.58337H18.4167V9.75004Z",
  fill: "currentColor"
});
function SvgTests(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "static/2.5.1/media/tests.6bd43b89.svg";
export { SvgTests as ReactComponent };